<template>
  <div 
    class="fts-contenteditable"
    :class="[
      textWrap ? 'content-wrap' : 'content-nowrap',
      {'disabled': !contenteditable}
    ]"
    :contenteditable="contenteditable"
    v-once
    v-html="value"
    :value="value"
    :spellcheck="spellcheck"
    :placeholder="placeholder"
    @input="onInput"
    @focus="onFocus"
    @blur="onBlur"
    @paste.prevent="onPaste($event)"
    @keydown.enter="onEnter($event)"
    @mousedown="onMousedown"
    tabindex="0"
  >
  </div>
</template>

<script>

let mousedownEvent = false; 

export default {
  props: {
    value: {
      type: String,
    },
    contenteditable: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "Untitled"
    },
    textWrap: Boolean,
    spellcheck: Boolean,
    search: Boolean,
    multipleLine: Boolean,
    debounceTime: {
      type: Number,
      default: 800,
    },
    autofocus: Boolean,
  },
  methods: {
    onInput($event) {
      let val = $event.target.innerText;

      if (!this.multipleLine)
        val = val.replace(/\n|\r/g, "");
 
      this.$emit('input', val);

      if (this.search)
        this.debounceSearch();
    },
    onFocus(e) {
      try {
        /* autofocus last range */
        if (
          e.relatedTarget && 
          e.target.firstChild &&
          !mousedownEvent
        ) {
          let range = document.createRange();
          let selection = window.getSelection();
          range.selectNodeContents(e.target.firstChild);
          range.setStart(e.target.firstChild, range.endOffset);
          range.setEnd(e.target.firstChild, range.endOffset);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      } catch(err) {
        console.warn("[DOMException]", err);
      }
      mousedownEvent = false;
      this.$emit('input:focus');
    },
    onBlur() {
      this.$emit('input:blur');
    },
    onPaste(e) {
      var text = e.clipboardData.getData("text/plain");
      document.execCommand("insertHTML", false, text);
      this.$emit('input:paste');
    },
    onEnter(e) {
      if (!this.multipleLine)
        e.preventDefault();

      this.$emit('keydown:enter');
    },
    onMousedown() {
      mousedownEvent = true;
    },
    onSearch() {
      this.$emit('input:search');
    },
  },
  computed: {
    debounceSearch() {
      return _.debounce(this.onSearch, this.debounceTime);
    },
  },
  watch: {
    value: function (val) {
      if (document.activeElement == this.$el) return;

      if (val)
        this.$el.innerHTML = this.multipleLine ? val : val.replace(/\n|\r/g, "");
      else
        this.$el.innerHTML = "";
    }
  },
  mounted() {
    if (this.autofocus) this.$el.focus();
  },
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-contenteditable {
  width: 100%;
  word-break: break-word;
  cursor: text;
  &:empty:before {
    content: attr(placeholder);
    -webkit-text-fill-color: inherit;
    opacity: .45;
  }
  &.content-nowrap {
    overflow: hidden;
    white-space: nowrap;
  }
  &.content-wrap {
    word-break: break-word;
  }
  &.disabled {
    cursor: default;
  }
}
</style>